module.exports = __webpack_public_path__ + "static/img/5.a9e974b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/zh/5.png
// module id = 4pYl
// module chunks = 0